import { render } from "./ViewContent.vue?vue&type=template&id=6b4a1fa0&scoped=true"
import script from "./ViewContent.vue?vue&type=script&lang=js"
export * from "./ViewContent.vue?vue&type=script&lang=js"

import "./ViewContent.vue?vue&type=style&index=0&id=6b4a1fa0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4a1fa0"]])

export default __exports__